import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';

const Impressum: React.FC = () => {
  return (
    <div className="min-h-screen animated-bg pt-24 pb-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Back Button */}
        <motion.div 
          className="mb-8"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <a 
            href="/" 
            className="inline-flex items-center text-primary-400 hover:text-primary-300 transition-colors"
          >
            <ArrowLeft size={20} className="mr-2" />
            Zurück zur Startseite
          </a>
        </motion.div>

        {/* Header */}
        <motion.div 
          className="text-center mb-12"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Impressum
          </h1>
          <p className="text-xl text-gray-300">
            Rechtliche Angaben und Kontaktinformationen
          </p>
        </motion.div>

        {/* Content */}
        <motion.div 
          className="card space-y-8"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          {/* Section 1 */}
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">Angaben gemäß § 5 TMG</h2>
            <div className="bg-dark-800/50 border border-primary-500/20 rounded-lg p-6">
              <p className="text-white text-lg">
                <strong>Oliver Kriz</strong><br />
                Amtstr. 22<br />
                44575 Castrop-Rauxel
              </p>
            </div>
          </section>

          {/* Section 2 */}
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">Kontakt</h2>
            <div className="bg-dark-800/50 border border-primary-500/20 rounded-lg p-6">
              <p className="text-white text-lg">
                E-Mail: olli@tech4.stream
              </p>
            </div>
          </section>

          {/* Section 3 */}
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">Umsatzsteuer-ID</h2>
            <div className="bg-dark-800/50 border border-primary-500/20 rounded-lg p-6">
              <p className="text-white text-lg">
                Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
                <strong>DE245093399</strong>
              </p>
            </div>
          </section>

          {/* Section 4 */}
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">Inhaltlich Verantwortlicher</h2>
            <div className="bg-dark-800/50 border border-primary-500/20 rounded-lg p-6">
              <p className="text-white text-lg">
                Oliver Kriz<br />
                Amtstr. 22<br />
                44575 Castrop-Rauxel
              </p>
            </div>
          </section>

          {/* Section 5 */}
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">Haftungsausschluss</h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-semibold text-primary-400 mb-3">Haftung für Inhalte</h3>
                <p className="text-gray-300 leading-relaxed">
                  Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-primary-400 mb-3">Haftung für Links</h3>
                <p className="text-gray-300 leading-relaxed">
                  Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
                </p>
              </div>
            </div>
          </section>
        </motion.div>
      </div>
    </div>
  );
};

export default Impressum;
